import { VueRecaptcha } from 'vue-recaptcha';
import axios from '../../api/common/axios';

export default {
  name: 'loginForm',
  components: {
    'vue-recaptcha': VueRecaptcha
  },
  data() {
    return {
      isLoading: false,
      isForgot: false,
      isSmartPhone: window.tom.user.isSmartPhoneDevice,
      email: '',
      password: '',
      flashMessage: {
        type: 'danger',
        body: window.options.flashMessage
      },
      errorMessages: {
        email: '',
        password: ''
      },
      form: window.options.form,
      redirect: window.options.redirect,
      reAuth: window.options.reAuth
    };
  },
  watch: {
    email() {
      const field = this.$validator.fields.find({
        name: 'email'
      });
      field.reset();
      this.errors.remove('email');
      this.errorMessages.email = '';
    }
  },
  computed: {
    singupUrl() {
      return '/signup' + window.location.search;
    }
  },
  methods: {
    getUrl(url) {
      let params = [];
      if (this.form === 'reAuth') {
        params.push('re_auth=1');
      }
      if (this.redirect && this.redirect !== '/') {
        params.push('r=' + encodeURIComponent(this.redirect));
      }

      if (params.length > 0) {
        return `${url}?${params.join('&')}`;
      }

      return url;
    },
    switchForm() {
      this.resetErrorMessages();
      this.isForgot = !this.isForgot;
    },
    resetErrorMessages() {
      this.errorMessages.email = '';
      this.errorMessages.password = '';
      this.flashMessage.body = '';
    },
    submit() {
      if (this.isForgot) {
        return this.forgot();
      }
      return this.login();
    },
    login() {
      window.tom.helper.ga.push([
        'event',
        'EmailLogin',
        'Clicked',
        'Button',
        1
      ]);

      this.isLoading = true;
      this.$refs.recaptcha.execute();
    },
    forgot() {
      this.isLoading = true;
      this.resetErrorMessages();

      const data = {
        email: this.email
      };
      axios
        .post('/auth/forgot', data)
        .then((response) => {
          if (response.data.status === 'success') {
            this.flashMessage.type = 'success';
            this.flashMessage.body =
              response.data.body ||
              'Success. You will receive an email from us.';
          } else {
            if (response.data.errors.email) {
              return (this.errorMessages.email =
                response.data.errors.email.msg);
            }
          }
        })
        .catch((err) => {
          const errData = err.response.data;
          this.flashMessage.type = 'danger';
          this.flashMessage.body = errData.err
            ? errData.err.common
            : 'An error occurred. Please wait a moment before trying again.';
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    async resendVerification() {
      this.isLoading = true;
      this.resetErrorMessages();
      try {
        const response = await axios.post('/signup/resend_verification');
        if (response.data.status === 'ok') {
          this.flashMessage.type = 'success';
          this.flashMessage.body =
            'Success. You will receive an email from us.';
        } else {
          this.flashMessage.type = 'danger';
          this.flashMessage.body =
            response.data.errors?.general || 'An error occurred.';
        }
      } catch (err) {
        this.flashMessage.type = 'danger';
        this.flashMessage.body =
          'An error occurred. Please wait a moment before trying again.';
      } finally {
        this.isLoading = false;
      }
    },
    onCaptchaVerified(recaptchaToken) {
      this.resetErrorMessages();
      this.$refs.recaptcha.reset();

      const data = {
        fromLoginForm: true,
        re_auth: this.reAuth,
        email: this.email,
        password: this.password,
        redirect: this.redirect,
        has_remember_me: 'yes',
        'g-recaptcha-response': recaptchaToken
      };

      axios
        .post('/auth/tom', data)
        .then((response) => {
          // ラベルフォロー処理
          if (window.options.followLabelId) {
            this.$store
              .dispatch('labels/follow', window.options.followLabelId)
              .then(() => {
                this.$emit('registered', response.data.redirect);
              });
          } else {
            this.$emit('registered', response.data.redirect);
            //window.location.href = response.data.redirect || '/';
          }
        })
        .catch((err) => {
          this.isLoading = false;

          if (err.response) {
            const errData = err.response.data;

            if (errData.err.common) {
              this.flashMessage.body = errData.err.common;
            }
            if (errData.err.email) {
              this.errorMessages.email = errData.err.email;
            }
            if (errData.err.password) {
              this.errorMessages.password = errData.err.password;
            }
          }
        });
    },
    onCaptchaExpired() {
      this.isLoading = false;
      this.$refs.recaptcha.reset();
    },
    onCaptchaError() {
      this.isLoading = false;
      this.flashMessage.type = 'danger';
      this.flashMessage.body =
        'An error occurred. Please wait a moment before trying again.';
    },
    onPasswordChange(e) {
      this.password = e.target.value;
    }
  }
};
